var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1855 1.72723C17.5302 2.0141 16.8357 2.20137 16.125 2.2828C16.87 1.84381 17.4298 1.14876 17.6999 0.327352C16.9939 0.739716 16.2233 1.0299 15.4207 1.18565C15.0826 0.832747 14.6765 0.552087 14.2269 0.360649C13.7772 0.16921 13.2934 0.0709714 12.8047 0.071875C11.8606 0.0648867 10.9523 0.433131 10.2796 1.09564C9.60695 1.75815 9.22491 2.66069 9.21751 3.60481C9.21751 3.87662 9.24813 4.14464 9.30938 4.40887C7.88718 4.34132 6.49472 3.97783 5.22097 3.34164C3.94722 2.70544 2.82019 1.81052 1.9119 0.714068C1.45364 1.49194 1.31321 2.41664 1.51988 3.29549C1.72656 4.17434 2.26439 4.93955 3.02131 5.43165C2.45259 5.41372 1.8958 5.26397 1.39482 4.99419V5.03794C1.40039 5.85914 1.69033 6.65306 2.21529 7.28458C2.74026 7.91611 3.46783 8.34623 4.27419 8.50176C3.74426 8.6431 3.18941 8.66402 2.65034 8.563C2.88619 9.2689 3.33526 9.88422 3.93561 10.3241C4.53596 10.764 5.25801 11.0067 6.00217 11.0189C4.48905 12.1811 2.58171 12.706 0.687012 12.4818C2.33371 13.5231 4.24282 14.0742 6.19115 14.0706C7.52514 14.0907 8.84981 13.8453 10.0881 13.3486C11.3263 12.852 12.4534 12.114 13.4038 11.1777C14.3542 10.2414 15.1089 9.12543 15.624 7.89472C16.1391 6.66402 16.4043 5.34317 16.4041 4.00903C16.4041 3.85417 16.4041 3.70368 16.3936 3.55144C17.0966 3.05705 17.7037 2.43892 18.1855 1.72723Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.20b9c7235b8baae04d28493624a60ffa.svg";
export { ForwardRef as ReactComponent };